import { useMemo } from 'react';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, deleteAction, editAction, defaultActionsColumn, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

import ContentTypeFormatter from './ContentTypeFormatter'
import MultipleDomainsFormatter from './MultipleDomainsFormatter'

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('path', {
      header: 'Description',
      cell: info => <NameAndCreateDateFormatter info={info} />,
    }),
    column.accessor('content_type', {
      header: 'Content Type',
      cell: info => <ContentTypeFormatter info={info} />,
    }),
    defaultActiveColumn(),
    defaultColumn('meta', 'Multiple Domains', multipleDomainsToggleFormatter, { maxSize: 120 }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}

function multipleDomainsToggleFormatter(info) {
  return <MultipleDomainsFormatter key={keyOf(info)} info={info} />
}
